<template>
  <div id="LEQ-essay">
    <b-container fluid class="background">
      <b-row class="pt-4 pb-2 title top-nav-row responsive-padding">
        <b-col class="px-0">
          <a
            class="strip top-back-link"
            @click="handleBack()"
            >&larr; Back</a
          >
        </b-col>
      </b-row>
      <b-row class="responsive-padding breadcrumb-row">
        <breadcrumb :items="items"></breadcrumb>
      </b-row>
      <section class="page-hero responsive-padding">
        <h1 class="page-title">LEQ Essay</h1>
        <p class="page-subtitle">{{ pageSubtitle }}</p>
      </section>
      <b-row class="white-container responsive-padding">
        <essayhead :prompt="exersize.prompt" :timer="timer"></essayhead>
        <progressvue
          v-if="moduleVersion !== 'Expert'"
          :section="currentSection"
          class="my-4"
        ></progressvue>
        <essayarea
          v-if="moduleVersion !== 'Expert'"
          :props="exersize"
          :moduleVersion="moduleVersion"
          :identification="id"
          @updateProgress="section => handleUpdate(section)"
        ></essayarea>
        <outlinevue
          v-if="moduleVersion === 'Expert'"
          class="my-4"
          :outlineText="
            exersize.template.templates.raw
              ? exersize.template.templates.raw.outline
              : null
          "
          :totalEmits="totalEmits"
          @TimedOutline="outline => handleOutline(outline)"
        ></outlinevue>
        <timedessayarea
          v-if="moduleVersion === 'Expert'"
          :moduleVersion="moduleVersion"
          :promptId="id"
          :text="
            exersize.template.templates.raw
              ? exersize.template.templates.raw.text
              : null
          "
          @TimedSubmit="essay => handleTimedSubmit(essay)"
        ></timedessayarea>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import breadcrumb from "../../components/writing_feature/BreadCrumb.vue";
import essayarea from "../../components/writing_feature/LEQEssay/BeginnerEssayArea.vue";
import progressvue from "../../components/writing_feature/LEQEssay/Progress.vue";
import essayhead from "../../components/writing_feature/LEQEssay/EssayHead.vue";
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { pushRoute } from "@/router/navigation";
import storeWriting from "../../store/writing";
import { trackEvent } from "@/services/analyticsService";
import timedessayarea from "../../components/writing_feature/LEQEssay/ExpertTimedEssayArea.vue";
import outlinevue from "../../components/writing_feature/LEQEssay/Outline.vue";
export default {
  components: {
    breadcrumb,
    essayarea,
    progressvue,
    essayhead,
    timedessayarea,
    outlinevue
  },
  setup() {
    const totalEmits = ref(0); // if both components for the timed module emit their user writing (i.e total emits === 2), the data will be packaged and a store action will trigger
    const route = useRoute();
    const moduleVersion = route.params.module;
    const timer = ref(null);
    if (!["Beginner", "Intermediate", "Expert"].includes(route.params.module)) {
      pushRoute("001");
    }
    const store = storeWriting;
    const id = route.params.id;
    const exersize = store.getters.findPrompt({
      id: id,
      version: moduleVersion
    });
    console.log("initial fetch", id, exersize);
    const items = [
      {
        text: "Essay Writing: LEQ"
      },
      {
        text: "Choose a Prompt"
      },
      {
        text: "LEQ Essay",
        active: "yes!"
      }
    ];

    const buttonprops = ref({
      content: "Get Started",
      route: "SelectModule",
      disabled: false
    });

    //BREAKDOWN SECTION UPDATES
    const currentSection = ref(null);
    const handleUpdate = section => {
      currentSection.value = section;
    };

    const handleBack = () => {
      pushRoute("002", { module: moduleVersion });
    };

    const pageSubtitle = computed(() =>
      moduleVersion === "Expert"
        ? "Draft your essay and submit it when you are ready for the next step."
        : "Follow each section below to build your LEQ response step by step."
    );

    //TIMED MODULE STORE ACTIONS
    // updating store for Timed module submissions handled here, Beginner and Advanced are handled in EssayArea component
    const timedEssay = ref(null);
    const handleTimedSubmit = essay => {
      totalEmits.value++;
      timedEssay.value = essay;
      if (totalEmits.value >= 2) {
        trackEvent("essay_submitted", {
          prompt_id: id,
          module: moduleVersion
        });
      }
    };
    const handleOutline = outline => {
      store.dispatch("setUserInput", {
        prompt_id: id, //ID to identify prompt
        id: store.getters.getUniqueId, //Unique ID assigned to new feedback obj (to be replaced by firestore id's)
        moduleVersion: moduleVersion, //For segregating beginner and advanced modules
        promptText: exersize && exersize.prompt ? exersize.prompt.prompt : "",
        raw: {
          outline: outline,
          text: timedEssay.value
        }
      });

      console.log(
        "outline:",
        outline,
        "essay:",
        timedEssay.value,
        "store:",
        store.state.feedback
      );
    };
    onMounted(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      if (route.params.module === "Expert") {
        timer.value = 45;
      }
      trackEvent("essay_started", {
        prompt_id: id,
        module: moduleVersion
      });
    });
    return {
      items,
      buttonprops,
      exersize,
      handleUpdate,
      currentSection,
      id,
      handleBack,
      moduleVersion,
      pageSubtitle,
      timer,
      handleTimedSubmit,
      totalEmits,
      handleOutline
    };
  }
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Manrope:wght@700&display=swap");
#LEQ-essay {
  min-height: 100vh; /* Set a minimum height to ensure it fills the viewport. */
  height: 100%; /* Set the height to 100% to fill the available space. */
  display: flex; /* Use a flexbox layout to expand vertically. */
  flex-direction: column; /* Display children vertically. */
}

.top-nav-row {
  margin-bottom: 2px;
}

.top-back-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 8px 14px;
  border-radius: 999px;
  border: 1px solid #8c30f5;
  background: transparent;
  font-size: 16px;
  font-weight: 700;
  color: #8c30f5;
  line-height: 1;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease,
    box-shadow 0.15s ease, transform 0.15s ease;
}

.top-back-link:hover {
  color: #8c30f5;
  border-color: #8c30f5;
  background: rgba(140, 48, 245, 0.08);
  box-shadow: 0 4px 10px rgba(140, 48, 245, 0.2);
  transform: translateY(-1px);
  text-decoration: none;
}

.top-back-link:active {
  transform: translateY(0);
  box-shadow: 0 2px 5px rgba(140, 48, 245, 0.16);
}

.breadcrumb-row {
  margin-bottom: 4px;
}

.page-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 18px;
}

.page-title {
  margin: 0;
  color: #171717;
  font-size: clamp(1.8rem, 2.4vw, 2.35rem);
  font-weight: 800;
  line-height: 1.05;
}

.page-subtitle {
  margin: 8px 0 0;
  max-width: 700px;
  color: #4b5563;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4;
}

.white-container {
  width: 100%;
  max-width: 1080px;
  margin: 0 auto !important;
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
  padding-bottom: 96px;
}

@media (max-width: 991px) {
  .white-container {
    max-width: 100%;
  }
}
</style>
<style lang="sass" scoped src="@/assets/css/essayWriting.sass"></style>
